import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISort } from '@core/models/call-offer';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EsnCandidatService } from '@core/services/esn-candidat/esn-candidat.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '@core/services/local-storage.service';
import { EsnJobOfferService } from '@core/services/esn-job-offer-service/esn-job-offer.service';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { Router } from '@angular/router';
import { linkedInRegExp, patternEmail, patternfirstNamechiffre, patternNumbersOnly } from '@core/models/pattern';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-add-consultant-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  templateUrl: './add-consultant-modal.component.html',
  styleUrls: ['./add-consultant-modal.component.css']
})
export class AddConsultantModalComponent implements OnInit {
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @ViewChild('add_cos', { static: false }) modalContainer!: ElementRef;
  formconsultant: FormGroup = this.createconsultantForm();
  selectedconsultant: any;
  errorMessage: string = '';
  isexistemail = false;
  isButtonDisabled: boolean = false;
  iscv:boolean=false
  company_name: any;
  candidat_id: any;
  file: any = '';
  errorMessageprofil: string = '';
  isvalid: boolean = false;
  showResetButtons: boolean = true;
  fileName: string = '';
  fileError: string = '';
  fileExtention: string = '';
  listclient: { id: number; name: string }[] = [];
  client: any[] = [];
  listmanager: { id: number; full_name: string, first_name: string, last_name: string }[] = [];
  listconsultant: any;
  clientId2_name:any;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;

constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private jobofferservice: EsnJobOfferService,
     private esnconsultantservice: EsnConsultantService,
         private router: Router,
  ) {}
  ngOnInit(): void {
    this.getListclient()
    this.getListmanager()
      this.formconsultant = this.formBuilder.group(
        {
          candidate_id: [''],
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          email: [
            '',
            [
              Validators.required,
              Validators.email,
              Validators.pattern(patternEmail),
            ],
          ],
          emailProESN: ['', [Validators.email, Validators.pattern(patternEmail)]],
          linkedin_link: ['',Validators.pattern(linkedInRegExp)],
          cv: [''],
          desired_workstation: [''],
          date_signature_contrat: [''],
          mission_start_date: [{ value: '', disabled: true }],
          mission_end_date: [{ value: '', disabled: true }],
          salary: ['', [Validators.pattern(patternNumbersOnly)]],
          tjm_achat: ['', [Validators.pattern(patternNumbersOnly)]],
          tjm_vente: ['', [Validators.pattern(patternNumbersOnly)]],
          manager_id: [''],
          client_id: [''],
        },
        { validators: this.dateRangeValidator }
      );
  
      this.formconsultant = this.createconsultantForm();
  }

  getListconsultant() {
    this.spinner.show();
    let dataPyload = {
            per_page: this.itemsPerPage,
            page: this.currentPage,
        };

    this.esnconsultantservice.getListconsultant(dataPyload).subscribe({
      next: (response: any) => {
        this.spinner.hide();
        if (response.data && response.data.data) {
          this.listconsultant = response.data.data
          this.formconsultant
            .get('salary')
            ?.setValue(this.listconsultant.consultant_e_s_n_s_Salary);
          this.clientId2_name=response.data.data.clientId2_name
          this.totalItems = response.data.total;

        }
      },
      error: (error: any) => {
        if (error.error.message) {
          this.toastrService.error(error.error.message);
        }
        this.spinner.hide();
      },
    });
  }
  createconsultant() {
    
    this.formconsultant.markAllAsTouched();
    this.formconsultant.markAsDirty();
    this.setValidatorRequirements();

    if (!this.isexistemail) {
      let fromdata = new FormData();
      fromdata.append('first_name', this.formconsultant.value.first_name);
      fromdata.append('last_name', this.formconsultant.value.last_name);
      fromdata.append('email', this.formconsultant.value.email);
      if (this.formconsultant.value.emailProESN) {
        fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
      }
      if(this.formconsultant.value.date_signature_contrat)
      {
        fromdata.append('date_signature_contrat', this.formconsultant.value.date_signature_contrat);
      }
      if(this.formconsultant.value.linkedin_link){
      fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link)
      };
      if( this.formconsultant.value.desired_workstation)
      {
        fromdata.append('desired_workstation',this.formconsultant.value.desired_workstation );
      }
      if (this.formconsultant.value.tjm_achat) {
        fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
      }
      if (this.formconsultant.value.tjm_vente) {
        fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
      }
      if (this.formconsultant.value.salary) {
        fromdata.append('salary', this.formconsultant.value.salary);
      }
      if (this.formconsultant.value.manager_id) {
        fromdata.append('manager_id', this.formconsultant.value.manager_id);
      }
      if (this.formconsultant.value.client_id) {
        fromdata.append('client_id', this.formconsultant.value.client_id);
      } 
      if (this.file) {
        fromdata.append('cv', this.file);
      } 


      this.enableFormFields();
      this.esnconsultantservice.createconsultant(fromdata).subscribe({
        next: (response) => {
          this.toastrService.success('consultant a été ajouté avec succès');
          this.navigateToProfile(response.data.user_id);

          this.getListconsultant();
          this.close_modal_add();
        },
        error: (error: any) => {
          if (error?.status === 404) {
            this.toastrService.error('Utilisateur associé à une autre ESN.');
          } else if (error.error.message && typeof error.error.message === 'string') {
            this.toastrService.error(error.error.message);
          } else if (error?.error && error?.error?.data) {
            if (
              error.error.data.email &&
              error.error.data.email[0] === 'The email has already been taken.'
            ) {
              this.toastrService.error("L'email est déjà utilisé.");
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link must be a valid URL.'
            ) {
              this.toastrService.error(
                'Le lien LinkedIn doit être une URL valide.'
              );
            } else if (
              error.error.data.cv &&
              error.error.data.cv[0] === 'The cv field is required.'
            ) {
              this.toastrService.error('Le CV est requis.');
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link has already been taken.'
            ) {
              this.toastrService.error('LinkedIn est déjà utilisé.');
            } else  if (error.status === 403 && error.error.message) {
              this.toastrService.error(error.error.message);
          } else {
            this.toastrService.error("Une erreur inattendue s'est produite.");
          }
          }}

      });
    }
    else {
      if (this.company_name == null) {
        let data = {
          candidate_id: this.candidat_id,
          salary: this.formconsultant.value.salary,

          tjm_achat: this.formconsultant.value.tjm_achat,
          tjm_vente: this.formconsultant.value.tjm_vente,
          emailProESN: this.formconsultant.value.emailProESN,
          mission_start_date: this.formconsultant.value.mission_start_date,
          mission_end_date: this.formconsultant.value.mission_end_date,
          manager_id: this.formconsultant.value.manager_id
            ? this.formconsultant.value.manager_id
            : '',
          client_id: this.formconsultant.value.client_id
            ? this.formconsultant.value.client_id
            : '',
          date_signature_contrat:
            this.formconsultant.value.date_signature_contrat,
          desired_workstation: this.formconsultant.value.desired_workstation,
        };
        this.disableFormFields();
        this.esnconsultantservice.createconsultant(data).subscribe({
          next: (response) => {
            this.toastrService.success('consultant a été ajouté avec succès ');

            this.getListconsultant();

            this.close_modal_add();
          },
          error: (error: any) => {
            if (error?.status === 404) {
              this.toastrService.error('Utilisateur associé à une autre ESN.');
            } else if (error?.error && error?.error?.data) {
              if (
                error.error.data.email &&
                error.error.data.email[0] ===
                  'The email has already been taken.'
              ) {
                this.toastrService.error("L'email est déjà utilisé.");
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link must be a valid URL.'
              ) {
                this.toastrService.error(
                  'Le lien LinkedIn doit être une URL valide.'
                );
              } else if (
                error.error.data.cv &&
                error.error.data.cv[0] === 'The cv field is required.'
              ) {
                this.toastrService.error('Le CV est requis.');
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link has already been taken.'
              ) {
                this.toastrService.error("L'linkedin est déjà utilisé.");
              }
              else if (
                error.error && error.error.message ==='candidate was already a salary'
              ) {
                this.toastrService.error("La candidate est déjà salariée.");
              }else {
                this.toastrService.error(
                  "Une erreur inattendue s'est produite."
                );
              }
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          },
        });
      } else {
        let data = {
          candidate_id: this.candidat_id,
          salary: this.formconsultant.value.salary,
          tjm_achat: this.formconsultant.value.tjm_achat,
          tjm_vente: this.formconsultant.value.tjm_vente,

          emailProESN: this.formconsultant.value.emailProESN,
          mission_start_date: this.formconsultant.value.mission_start_date,
          mission_end_date: this.formconsultant.value.mission_end_date,
          manager_id: this.formconsultant.value.manager_id
            ? this.formconsultant.value.manager_id
            : '',
          client_id: this.formconsultant.value.client_id
            ? this.formconsultant.value.client_id
            : '',
          date_signature_contrat:
            this.formconsultant.value.date_signature_contrat,
        };
        this.disableFormFields();
        this.esnconsultantservice.createconsultant(data).subscribe({
          next: (response) => {
            this.toastrService.success('consultant a été ajouté avec succès ');

            this.getListconsultant();

            this.close_modal_add();
          },
          error: (error: any) => {
            this.toastrService.error(`Une erreur inattendue s'est produite. ${error.error.message}`);
            if (error?.status === 404) {
              this.toastrService.error('Utilisateur associé à une autre ESN.');
            } else if (error?.error && error?.error?.data) {
              if (
                error.error.data.email &&
                error.error.data.email[0] ===
                  'The email has already been taken.'
              ) {
                this.toastrService.error("L'email est déjà utilisé.");
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link must be a valid URL.'
              ) {
                this.toastrService.error(
                  'Le lien LinkedIn doit être une URL valide.'
                );
              } else if (
                error.error.data.cv &&
                error.error.data.cv[0] === 'The cv field is required.'
              ) {
                this.toastrService.error('Le CV est requis.');
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link has already been taken.'
              ) {
                this.toastrService.error("L'linkedin est déjà utilisé.");
              } else {
                this.toastrService.error(
                  "Une erreur inattendue s'est produite."
                );
              }
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          },
        });
      }
    }
  }
  navigateToProfile(consultantId: any) {
    this.router.navigate([
      '/candidats/profilecandidatesn',
      consultantId,
    ]);
  }
  isDateRangeValid(): boolean {
    return !this.formconsultant.hasError('dateRangeInvalid');
  }
  getListclient() {
    this.esnconsultantservice.getclient().subscribe({
      next: (response) => {
        if (response.data) {
          this.listclient = response.data;
          this.client = response.data;
        }
      },
      error: (error) => {
      },
    });
  }

  getListmanager() {
    this.esnconsultantservice.getmanagernew().subscribe({
      next: (response) => {
        if (response.data) {
          this.listmanager = response.data.map((el: any) => {
            return {
              ...el,
              full_name: `${el.first_name} ${el.last_name}`
            };
          });
        }
      },
      error: (error) => {
      },
    });
  }
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    this.formconsultant.get('cv')?.setValue(this.file);
  }

  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
      this.fileExtention = '';
      this.fileError = '';
      this.isvalid = true;
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
   setValidatorRequirements() {
  
      const linkedinControl = this.formconsultant.get('linkedin_link');
      const cvControl = this.formconsultant.get('cv');
  
      // Effacer les validateurs existants
      linkedinControl?.clearValidators();
      cvControl?.clearValidators();
  
      if (!linkedinControl?.value && !cvControl?.value) {
        linkedinControl?.setValidators([
          Validators.pattern(linkedInRegExp),
        ]);
      } else {
        if (linkedinControl?.value) {
          linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
        }
        if (cvControl?.value) {
          cvControl?.clearValidators();
          // linkedinControl?.clearValidators();
        }
      }
  
      linkedinControl?.updateValueAndValidity({ emitEvent: false });
      cvControl?.updateValueAndValidity({ emitEvent: false });
    }
  createconsultantForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [
          data?.first_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        last_name: [
          data?.last_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        emailProESN: [
          data?.emailProESN || '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data?.email || '',
          [Validators.required, Validators.pattern(patternEmail)],
        ],
        linkedin_link: [data?.linkedin_link || ''],
        cv: [data?.cv || ''],
        desired_workstation: [data?.desired_workstation || ''],
        date_signature_contrat: [data?.date_signature_contrat || ''],
        salary: [data?.salary || null],
        tjm_achat: [data?.tjm_achat || ''],
        tjm_vente: [data?.tjm_vente || ''],
        manager_id: [data?.manager_id || null],
        client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
        candidate_id: [data?.candidate_id || ''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        mobility: [data?.mobility || []],
        desired_contract: [data?.desired_contract || []],
        softSkills: [data?.softSkills || []],
        destination_country: [data?.destination_country || []],
        skills_text: [data?.skills_text || []],
      },
      { validator: this.dateRangeValidator }
    );
  }


  enableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.enable();
      this.formconsultant.get('last_name')?.enable();
      this.formconsultant.get('emailProESN')?.enable();
      this.formconsultant.get('linkedin_link')?.enable();
      this.formconsultant.get('desired_workstation')?.enable();
      this.formconsultant.get('cv')?.enable();
    }
  }

  getconsultantByEmail(event: any) {
    this.errorMessage = '';
    //this.formconsultant.reset();
    const enteredEmail = event.target.value.trim();

    if (enteredEmail === '') {
      this.enableFormFields();
      this.formconsultant.get('linkedin_link')?.enable();
      this.selectedconsultant = '';
      this.formconsultant.patchValue({
        first_name: '',
        last_name: '',
        linkedin_link: '',
        cvName: '',
        desired_workstation: '',
      });
      this.isexistemail = false;
      this.isButtonDisabled = false;
      this.errorMessage = '';
      return;
    }

    this.esnconsultantservice.getconsultantbyemail(enteredEmail)
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.isexistemail = true;
            if(res.data.cv && res.data.cv!=='null'){
              this.iscv=true
             }
             else{
              this.iscv=false
             }

            this.formconsultant.get('linkedin_link')?.enable();
            this.company_name = res.company_name;
            this.selectedconsultant = res.data.cv;
            this.candidat_id = res.data.id;
            if (enteredEmail !== res.data.email) {
              this.formconsultant.get('linkedin_link')?.enable();
              this.formconsultant.patchValue({
                first_name: '',
                last_name: '',
                selectedconsultant: '',
                desired_workstation: '',
              });
              this.isexistemail = false;
              this.isButtonDisabled = false;
              this.errorMessage = '';
              return;
            }

            this.formconsultant.patchValue({
              email: res.data.email,
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              linkedin_link: res.data.linkedin_link,
              cv: res.data.cv,
              desired_workstation: res.data.desired_workstation,
              client_name: res.client_name,
            });
            if (res.data.cv) {
              this.file = { name: res.data.cv };
            }

            this.errorMessage = '';
            this.isButtonDisabled = false;

            if (
              res.data.linkedin_link !== null &&
              res.data.linkedin_link !== ''
            ) {
              this.formconsultant.get('linkedin_link')?.disable();
            } else {
              this.formconsultant.get('linkedin_link')?.enable();
            }

            this.disableFormFields();
          } else {
            this.isexistemail = true;

            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
        },
        error: (error: any) => {
          this.isexistemail = false;
          this.iscv=false
          this.enableFormFields()
          this.formconsultant.patchValue({
            first_name: '',
            last_name: '',
            selectedconsultant: '',
            desired_workstation: '',
            cv:'',
            linkedin_link:'',
          });
          if (
            error?.error?.message === 'User already associated with this ESN'
          ) {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à cet ESN."';
          }
          if (error?.error?.message === 'User associated with another ESN') {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
          if (error?.error?.message === 'User profile was not completed') {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessageprofil = '"Le profil utilisateur n\'a pas été complété"';
          }
        },
      });
    if (
      this.formconsultant.value.linkedin_link === undefined &&
      this.formconsultant.value.cv === undefined &&
      this.formconsultant.value.cv !== null &&
      this.formconsultant.value.linkedin_link !== null
    ) {
      this.isvalid = true;
    } else {
      this.isvalid = false;
    }
  }

  disableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.disable();
      this.formconsultant.get('last_name')?.disable();


    }
  }
  close_modal_add() {
     this.formconsultant.reset();
    this.formconsultant.get('email')?.setValue('');
    this.isButtonDisabled = false;
    this.isOpen=false
    this.selectedconsultant = '';
    let btnClose = document.getElementById('ModalClose_add_consultant');
    if (btnClose) {
      this.close.emit();
      btnClose.click();
      this.formconsultant.reset();
    
      this.errorMessage = '';
      this.selectedconsultant = '';

    }

    this.enableFormFields();
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.selectedconsultant = '';
    this.showResetButtons = false;
 
    this.iscv=false 
  }
   dateRangeValidator(
      control: AbstractControl
    ): { [key: string]: boolean } | null {
      const startDate = control.get('mission_start_date')!.value;
      const endDate = control.get('mission_end_date')!.value;
  
      if (startDate && endDate && startDate > endDate) {
        return { dateRangeInvalid: true };
      }
  
      return null;
    }

  closeModal() {
    this.close.emit();
  }

   _control(name:any) {
    return this.formconsultant.get(name);
  }
}
